import React from 'react';
import { Router } from '@reach/router';
import Layout from '../../components/layout';
import ResearchComponent from '../../components/about/Research';

const Research = ({ location }) => {
  const headerText =
    location.pathname === '/about/' || '/about' ? 'ABOUT iDECIDE' : null;

  return (
    <Layout headerText={headerText} heroFont="has-text-white" heroBg="fields">
      <Router>
        <ResearchComponent path="/about/research" />
      </Router>
    </Layout>
  );
};

export default Research;
